<template>
  <div class="pc-card">
    <div class="pc-header">
      <div class="pc-title">📊 持仓</div>
      <button v-if="positions.length > 0" class="pc-btn-close-all" @click="$emit('closeAll')">
        平全部
      </button>
    </div>
    <div v-if="positions.length === 0" class="pc-empty">
      暂无持仓
    </div>
    <div v-else class="pc-list">
      <div v-for="(pos, idx) in positions" :key="idx" class="pc-item">
        <div class="pc-item-header">
          <div class="pc-symbol">{{ pos.symbol }}</div>
          <div class="pc-direction" :class="pos.direction">
            {{ pos.direction === 'long' ? '多' : '空' }}
          </div>
        </div>
        <div class="pc-item-body">
          <div class="pc-row">
            <span class="pc-label">数量</span>
            <span class="pc-value">{{ pos.quantity }}手</span>
          </div>
          <div class="pc-row">
            <span class="pc-label">开仓价</span>
            <span class="pc-value">{{ pos.entry_price }}</span>
          </div>
          <div class="pc-row">
            <span class="pc-label">当前价</span>
            <span class="pc-value">{{ pos.current_price }}</span>
          </div>
          <div class="pc-row">
            <span class="pc-label">盈亏</span>
            <span class="pc-value" :class="pos.pnl >= 0 ? 'profit' : 'loss'">
              {{ formatPnl(pos.pnl) }}
            </span>
          </div>
        </div>
        <button class="pc-btn-close" @click="handleClose(pos)">
          平仓
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PositionCard',
  props: {
    positions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleClose(pos) {
      this.$emit('close', pos.position_id || pos.id)
    },
    formatPnl(value) {
      const num = value || 0
      return (num >= 0 ? '+' : '') + `¥${num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
    }
  }
}
</script>

<style scoped>
.pc-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--tv-border);
}

.pc-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--tv-text);
}

.pc-btn-close-all {
  background: rgba(242, 54, 69, 0.15);
  color: var(--tv-danger);
  border: 1px solid rgba(242, 54, 69, 0.3);
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 10px;
  cursor: pointer;
  font-weight: 500;
  height: 22px;
  line-height: 14px;
  white-space: nowrap;
}

.pc-btn-close-all:hover {
  background: rgba(242, 54, 69, 0.25);
  border-color: rgba(242, 54, 69, 0.5);
}

.pc-empty {
  text-align: center;
  padding: 12px;
  color: var(--tv-text-muted);
  font-size: 10px;
}

.pc-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pc-item {
  background: var(--tv-panel);
  border: 1px solid var(--tv-border);
  border-radius: 3px;
  padding: 6px;
}

.pc-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.pc-symbol {
  font-weight: 600;
  font-size: 11px;
  color: var(--tv-text);
}

.pc-direction {
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 9px;
  font-weight: 600;
  white-space: nowrap;
}

.pc-direction.long {
  background: rgba(8, 153, 129, 0.12);
  color: var(--tv-success);
}

.pc-direction.short {
  background: rgba(242, 54, 69, 0.12);
  color: var(--tv-danger);
}

.pc-item-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 6px;
}

.pc-row {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  padding: 1px 0;
}

.pc-label {
  color: var(--tv-text-muted);
}

.pc-value {
  font-weight: 500;
  color: var(--tv-text);
  font-size: 11px;
}

.pc-value.profit {
  color: #f23645;
}

.pc-value.loss {
  color: #089981;
}

.pc-btn-close {
  width: 100%;
  background: var(--tv-bg);
  color: var(--tv-text);
  border: 1px solid var(--tv-border);
  padding: 5px;
  border-radius: 3px;
  font-size: 10px;
  cursor: pointer;
  font-weight: 500;
  height: 24px;
  line-height: 14px;
  white-space: nowrap;
}

.pc-btn-close:hover {
  background: var(--tv-panel);
  border-color: var(--tv-primary);
  color: white;
}
</style>
